const KmHistoryModal = ({ vehicle, logs, darkMode, onClose }) => {
  const getTripTypeLabel = (type) => {
    const labels = {
      'business': 'Serviço',
      'personal': 'Pessoal',
      'commute': 'Casa-Trabalho',
      'client_visit': 'Visita Cliente',
      'other': 'Outro'
    };
    return labels[type] || type || '-';
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className={`rounded-xl w-full max-w-3xl max-h-[85vh] overflow-hidden ${darkMode ? 'bg-slate-800' : 'bg-white'}`} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className={`p-6 border-b ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
          <div className="flex items-center justify-between">
            <div>
              <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Histórico de Quilómetros</h2>
              <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                {vehicle.brand} {vehicle.model} - <span className="font-mono font-bold text-blue-500">{vehicle.license_plate}</span>
              </p>
            </div>
            <div className={`text-right px-4 py-2 rounded-lg ${darkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
              <p className={`text-xs ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Km Atual</p>
              <p className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>{vehicle.current_km?.toLocaleString('pt-PT')} km</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-180px)]">
          {logs.length === 0 ? (
            <div className="text-center py-12">
              <span className="text-5xl block mb-4">📊</span>
              <p className={darkMode ? 'text-slate-400' : 'text-slate-500'}>Sem registos de quilómetros</p>
              <p className={`text-sm mt-1 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Clique em &quot;Registar KM&quot; para adicionar o primeiro registo</p>
            </div>
          ) : (
            <div className="space-y-3">
              {logs.map((log, idx) => (
                <div key={log.log_id || idx} className={`p-4 rounded-lg border ${darkMode ? 'bg-slate-700/30 border-slate-600' : 'bg-slate-50 border-slate-200'}`}>
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                        log.trip_type === 'business' ? 'bg-blue-100 text-blue-600' :
                        log.trip_type === 'personal' ? 'bg-purple-100 text-purple-600' :
                        'bg-slate-200 text-slate-600'
                      }`}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                      </div>
                      <div>
                        <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{log.date}</p>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          log.trip_type === 'business' ? 'bg-blue-100 text-blue-700' :
                          log.trip_type === 'personal' ? 'bg-purple-100 text-purple-700' :
                          'bg-slate-200 text-slate-600'
                        }`}>
                          {getTripTypeLabel(log.trip_type)}
                        </span>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>{log.km?.toLocaleString('pt-PT')} km</p>
                      <p className={`text-sm ${log.km_difference > 0 ? 'text-emerald-500' : (darkMode ? 'text-slate-400' : 'text-slate-500')}`}>
                        {log.km_difference > 0 ? `+${log.km_difference?.toLocaleString('pt-PT')} km` : '-'}
                      </p>
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-3">
                    {log.destination && (
                      <div>
                        <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Destino</p>
                        <p className={`text-sm ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{log.destination}</p>
                      </div>
                    )}
                    {log.purpose && (
                      <div>
                        <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Motivo</p>
                        <p className={`text-sm ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{log.purpose}</p>
                      </div>
                    )}
                  </div>
                  
                  {log.notes && (
                    <div className="mt-2">
                      <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Notas</p>
                      <p className={`text-sm italic ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{log.notes}</p>
                    </div>
                  )}
                  
                  <div className={`mt-3 pt-2 border-t text-xs flex justify-between ${darkMode ? 'border-slate-600 text-slate-500' : 'border-slate-200 text-slate-400'}`}>
                    <span>Km anterior: {log.km_previous?.toLocaleString('pt-PT')} km</span>
                    <span>Registado por: {log.employee_name || '-'}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className={`p-6 border-t ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
          <div className="flex justify-between items-center">
            <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
              Total de registos: {logs.length}
            </p>
            <button
              onClick={onClose}
              className={`px-4 py-2 rounded-lg transition-colors ${
                darkMode ? 'bg-slate-700 text-white hover:bg-slate-600' : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
              }`}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KmHistoryModal;
